import styles from './index.module.scss';

interface LinearGradientCardProps {
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
}

const LinearGradientCard = (props: LinearGradientCardProps) => {
  const { className, children, onClick } = props;
  return (
    <div
      className={cls(styles.linearGradientCard, className)}
      onClick={() => onClick?.()}
    >
      <div className={styles.cardContent}>{children}</div>
    </div>
  );
};
export default LinearGradientCard;
